import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'frontend_apis-release_reloaded-action_unknown';
/**
 * Event emitted when a release is reloaded due to being flagged for needing a reload
 */
export function trackFrontendApisReleaseReloaded() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
    });
}
